import script from "./VoucherMerchantCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VoucherMerchantCard.vue?vue&type=script&setup=true&lang=ts"

import "./VoucherMerchantCard.vue?vue&type=style&index=0&id=04f2ba60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04f2ba60"]])

export default __exports__